import { Box, Flex } from "@chakra-ui/react";
import React, { Fragment } from "react";
import SubListSelector from "../../components/GameComponents/SubListSelector/SubListSelector";
import LiveGameSelector from "../../components/GameComponents/GameSelector/LiveGameSelector";
import Seo from "./seo";
import GameTypeSelector from "../../components/GameComponents/GameTypeSelector/GameTypeSelector";
import PlatformSelector from "../../components/GameComponents/PlatformSelector/PlatformSelector";
import GameSelector from "../../components/GameComponents/GameSelector/GameSelector";

const Lottery = ({ gameMainTypeFromProps }) => {
  return (
    <Fragment>
      <Seo />
      <Box as="section" px="common-y">
        <GameTypeSelector />
      </Box>
      <Box as="section" pt="home-space" px="common-y">
        <SubListSelector
          forceShowAll
          gameMainTypeFromProps={gameMainTypeFromProps}
        />
      </Box>
      {/* <Box as="section" pt="home-space" px="common-y">
        <MarqueeListV2 />
      </Box> */}

      <Box
        mt={{
          md: "0px",
          // base: "10px",
        }}
        pt="home-space"
      >
        {/* <MobileSearch listHidden /> */}
      </Box>
      <Box overflowY="scroll" flex={1}>
        <Box pb="home-space" px="common-y">
          <PlatformSelector gameMainTypeFromProps={gameMainTypeFromProps} />
        </Box>
        <Box py="home-space" px="common-y">
          <GameSelector gameMainTypeFromProps={gameMainTypeFromProps} />
        </Box>
      </Box>
    </Fragment>
  );
};

export default Lottery;
